import { render, staticRenderFns } from "./FacebookView.vue?vue&type=template&id=0c9f40d3"
import script from "./FacebookView.vue?vue&type=script&lang=js"
export * from "./FacebookView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports